<template lang="pug">

  .pageGroupsContainer

    //-
      -
      -
      -
      - CABEÇALHO DA LISTA
      -
      -
      -
      -

    .groupsHeader

      .sosGroupScreen__row.mb-2

        .sosGroupScreen__column.sosGroupScreen__column--50.sosGroupScreen__column--left

          h2.blockTitle Grupos
          span.blockDescription {{ pageDescription }}

        .sosGroupScreen__column.sosGroupScreen__column--50.sosGroupScreen__column--right

          sos-button(@buttonClick="goToCreateGroup" size="medium" color="success" buttonLabel="NOVO GRUPO" buttonIcon="mdi-plus" buttonIconSize="16" :disabled="loadingGroups !== 'LOADED' && loadingGroups !== 'NOT_FOUND' && loadingGroups !== 'NOT_ADMIN'" :pulse="loadingGroups === 'NOT_FOUND' || loadingGroups === 'NOT_ADMIN'")

    //-
      -
      -
      -
      - LISTA
      -
      -
      -
      -

    .pageBody

      //-
        -
        - ERRO NO CARREGAMENTO/PROCESSAMENTO
        -
        -

      .groupsContainer(v-if="loadingGroups === 'ERROR_PROFILE_FB' || loadingGroups === 'ERROR_PROFILE_API' || loadingGroups === 'ERROR_PLANS_API' || loadingGroups === 'ERROR_PROFILE_NOT_FOUND'")

        .text-center

          span.startTitle Não foi possível carregar a lista!
          br
          .pt-2
            span Por favor, recarregue a página ou&nbsp;
            a(href="https://wa.me/?phone=5513992061010" target="_blank") converse com o nosso suporte.

      //-
        -
        - AGUARDANDO
        -
        -

      .groupsContainer(v-else-if="loadingGroups === 'WAITING'")

        .loadingResult

          .buttonLoader
            span
          span.loadingText Inicializando...

      //-
        -
        - CARREGOU, MAS NÃO TEM GRUPOS VÁLIDOS
        -
        -

      .groupsContainer(v-else-if="loadingGroups === 'LOADING'")

        .loadingResult

          span.screenStatus Carregando grupos
          br
          .groupProgressBar
            .groupProgressBarInner(:style="{ width: ((loadingGroupsProgress/(userSession.userGroupsAmount || 0)) * 100) + '%' }")

      //-
        -
        - CARREGOU, MAS NÃO TEM GRUPOS VÁLIDOS
        -
        -

      .groupsContainer(v-else-if="loadingGroups === 'NOT_FOUND' || loadingGroups === 'NOT_ADMIN'")

        .text-center

          span.startTitle VAMOS COMEÇAR
          br
          .pt-2 Clique no botão "NOVO GRUPO" para iniciar um novo grupo.

      //-
        -
        - CARREGOU E TEM GRUPOS
        -
        -

      .groupsContainer(v-else-if="loadingGroups === 'LOADED'")

        table#sosGroupsTable(border="0" cellspacing="0" cellpadding="0")

          thead

            tr.sosGroupItem.sosGroupItemHeader
              th Nome do grupo
              //- th.text-center Membros criam plantões
              //- th.text-center Membros largam plantões
              th(width="350") Descrição
              //- th(width="50") DEBUG
              th.text-center Locais
              th(width="180").last.text-center Ações

          tbody

            tr(v-for="(groupItem, groupItemIndex) in groups" :key="'grupo_' + groupItem.groupID").sosGroupItem

              td(data-label="Nome do grupo")

                div
                  .groupItem
                    .groupItemImage(:style="{backgroundImage: ('url(' + groupItem.groupImage + ')')}")
                    .groupItemName(@click="openGroup(groupItem.groupID)")
                      | {{ groupItem.groupName || '&nbsp;' }}
                    sos-button(v-if="permissaoGrupoEditarDetalhes(groupItem.groupID)" @buttonClick="openGroupEditModal(groupItem)" size="small" color="lightgrey" buttonLabel="" buttonIcon="mdi-pencil" buttonIconSize="16" rounded).groupItemEditButton

              td(data-label="Descrição")

                div
                  .groupItemDescription
                    | {{ groupItem.groupDescription || '&nbsp;' }}

              td(data-label="Locais").text-center

                span {{ groupItem.groupLocations.length || '&nbsp;' }}

              td(data-label="Ações").text-center.last

                sos-button(@buttonClick="openGroup(groupItem.groupID)" size="regular" buttonLabel="Ver Escalas" buttonIcon="" buttonIconSize="16" :uppercase="false")

      //-
        -
        - DESLOGANDO
        -
        -

      .groupsContainer(v-else-if="loadingGroups === 'LEAVING'")

        .loadingResult

          .buttonLoader
            span
          span.loadingText Saindo...

      //-
        -
        - ESSA CONDIÇAO É CHAMADA QUANDO O USUÁRIO ACABOU DE LOGAR.
        - PARECE QUE NESSE MOMENTO O COMPONENTE AINDA NÃO RECEBEU/CARREGOU AS VARIÁVEIS DA STORE.
        -
        -

      .groupsContainer(v-else)

        .loadingResult

          .buttonLoader
            span
          span.loadingText Processando...

    //-
      -
      - COMPONENTES
      -
      -

    group-edit-modal(ref="mdGroupEditModal" @close="closeGroupEditModal")

</template>

<script>

  // VueX
  import { mapState } from 'vuex'

  // Constants
  import { GRUPO_EDITAR_DETALHES } from '@/constants'

  // Funções utilitárias
  import { processCapabilities } from '@/functions'

  // Componentes
  import GroupEditModal from '@/modals/GroupEditModal'
  import SosButton from '@/components/SosButton'

  export default {
    name: 'GroupsList',

    components: {
      'group-edit-modal': GroupEditModal,
      'sos-button': SosButton,
    },

    computed: {
      ...mapState({
        userSession: state => state.app.userSession,
        groups: state => state.app.groups,
        loadingGroups: state => state.app.loadingGroups,
        loadingGroupsProgress: state => state.app.loadingGroupsProgress,
      }),

      pageDescription ()
      {
        const isError = this.loadingGroups === 'ERROR_PROFILE_FB' || this.loadingGroups === 'ERROR_PROFILE_API' || this.loadingGroups === 'ERROR_PLANS_API' || this.loadingGroups === 'ERROR_PROFILE_NOT_FOUND'
        const isExiting = this.loadingGroups === 'LEAVING'
        const isWaiting = this.loadingGroups === 'WAITING'
        const isLoading = this.loadingGroups === 'LOADING'

        return (
          isError ? 'Erro!' : (
            isExiting ? 'Saindo...' : (
              isWaiting ? 'Inicializando...' : (
                isLoading ? 'Carregando...' : (
                  this.groups.length === 0 ? 'Você não está gerenciando nenhum grupo.' : (
                    this.groups.length === 1 ? 'Você está gerenciando 1 grupo.' : (
                      `Você está gerenciando ${this.groups.length} grupos.`
                    )
                  )
                )
              )
            )
          )
        )
      },
    },

    /* watch: {
      '$store.state.app.groups': function () {
        // [24/01/25] console.log('::: LISTA DE GRUPOS [watch]:', this.$store.state.app.groups)
      },
    }, */

    /* mounted () {
      // [24/01/25] console.log('GroupsList')
    }, */

    methods: {

      /**
       *
       * HANDLE SCALE EDIT MODAL
       *
       */

      openGroupEditModal (selectedGroup) {
        this.$refs.mdGroupEditModal.open(selectedGroup)
      },

      closeGroupEditModal (type) {
        // [24/01/25] console.log('::: closeGroupEditModal[type]:', type)
      },

      /**
       *
       * O USUÁRIO LOGADO TEM PERMISSÃO PARA EDITAR DETALHES DO GRUPO ESPECIFICADO?
       *
       */

      permissaoGrupoEditarDetalhes (groupID) {
        const foundGroup = !!this.userSession === true && !!this.userSession.uid === true && !!this.groups === true ? this.groups.find(g => g.groupID === groupID) : null
        const disabledCapabilities = !!foundGroup === true && !!foundGroup.groupUsers[this.userSession.uid] === true && !!foundGroup.groupUsers[this.userSession.uid].disabledCapabilities === true ? foundGroup.groupUsers[this.userSession.uid].disabledCapabilities : []
        const capabilities = processCapabilities(disabledCapabilities)
        return capabilities[GRUPO_EDITAR_DETALHES]
      },

      /**
       *
       * ?
       *
       */

      openGroup (groupID) {
        return this.$router.push(`/admin/grupos/${groupID}/escalas`)
      },

      goToCreateGroup () {
        // [24/01/25] console.log('::: ENTRANDO NA PÁGINA DE CONVITE POR MEIO DA LISTA DE GRUPOS')

        this.$router.push('/admin/grupos/criar')
      },
    },
  }

</script>

<style lang="sass" scoped>

  .startTitle
    font-size: 18px
    font-weight: 900

  // table#sosGroupsTable span
  //   word-break: break-word
  //   white-space: normal !important
  //   line-height: 1

  .groupItem
    position: relative

    display: inline-block

  .groupItemImage
    // transition-duration: 100ms
    // transition-property: transform

    // cursor: pointer

    position: absolute
    top: 0
    bottom: 0
    left: 0
    margin: auto 0

    display: inline-block
    vertical-align: middle
    width: 50px
    height: 50px
    border-radius: 50%
    background-position: center
    background-size: cover
    background-repeat: no-repeat
    box-shadow: 0 5px 7px -3px rgba(0, 0, 0, 0.2)

    // &:hover
    //   transform: scale(1.07)

  .groupItemName
    cursor: pointer

    // display: inline-block
    // vertical-align: middle
    display: flex
    align-items: center
    padding-left: 60px
    padding-right: 46px

    min-height: 50px

    // line-height: 1
    text-align: left
    word-break: break-word
    white-space: normal

    &:hover
      color: steelblue
      text-decoration: underline

  .groupItemDescription
    display: inline-block

    // line-height: 1
    text-align: left
    word-break: break-word
    white-space: normal

  .groupItemEditButton
    position: absolute
    top: 0
    bottom: 0
    right: 0
    margin: auto 0

</style>
